<template>
  <div class="home">
    <div class="positioning"></div>
    <div class="home-content">
      <div class="my-swipe" :autoplay="3000" indicator-color="white">
        <div class="swipe-item">
          <img src="../../assets/img/home/swipe-bg.png" alt="" />
          <div>
            <div class="label">
              {{ $t('home.slogan1') }}
            </div>
            <div class="label">
              {{ $t('home.slogan2_part1') }}<span class="pocket-color">{{ $t('home.slogan2_pocket') }}</span>{{
                $t('home.slogan2_part2') }}
            </div>

            <div class="desc">
              {{ $t('home.slogan3') }}
            </div>

            <div class="btn" >
              <div>
                {{ $t('home.explore') }}
                <img src="../../assets/img/home/icon5.png" alt="">
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="home-card">
        <img src="../../assets/img/home/icon1.png" alt="" />
        <div class="home-card-c">
          <div class="label">{{ $t('home.alliance_pack') }}: <span>{{usdtAmount}}U</span></div>
          <div class="desc">{{ $t('home.alliance_desc') }}</div>
        </div>
        <div class="btn" @click="buyPocket()">{{ $t('home.join_alliance') }}</div>
      </div>

      <div class="home-card1" @click="HomeClick(1)">
        <img src="../../assets/img/home/icon2.png" alt="" />
        <div class="home-card1-c">
          <div class="label">{{ $t('home.mall') }}</div>
          <div class="desc">{{ $t('home.mall_desc') }}</div>
        </div>
        <div class="arrow">
          <img src="../../assets/img/home/arrow-r.png" alt="" />
        </div>
      </div>

      <div class="home-card1" @click="HomeClick(2)">
        <img src="../../assets/img/home/icon3.png" alt="" />
        <div class="home-card1-c">
          <div class="label">{{ $t('home.ecosystem') }}</div>
          <div class="desc">{{ $t('home.ecosystem_desc') }}</div>
        </div>
        <div class="arrow">
          <img src="../../assets/img/home/arrow-r.png" alt="" />
        </div>
      </div>
    </div>

    <Popup class="home-popup-box" v-model="show" get-container="#app"  :close-on-click-overlay="false">
      <div class="home-popup-content">
        <img class="close" @click="show = false" src="../../assets/img/home/close.png" alt="" />

        <div class="title">{{ $t('home.referrer_title') }}</div>
        <Field v-model="value" :placeholder="$t('home.referrer_placeholder')" />

        <div class="btn" @click="bindUser()">
          {{ $t('home.confirm') }}
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup, Swipe, SwipeItem, Field } from "vant";
import NumberScroll from "@/components/NumberScroll.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import StarBorder from "@/components/StarBorder/StarBorder.vue";


import axios from 'axios'
import contractaa from '../contract/index.js';

import Web3 from 'web3'

let web3
web3 = new Web3(window.ethereum);
export default {
  components: {
    Popup,
    VSwipe: Swipe,
    VSwipeItem: SwipeItem,
    NumberScroll,
    AnimatedContent,
    StarBorder,
    Field,
  },
  name: "home",
  data() {
    return {
      show: false,
      value: "0x00000000000000000000",
      usdtAmount:0,

    };
  },

  methods: {
    HomeClick(v){
      if(v==1){
        this.$router.push({name:'mall'})
      }else if(v==2){
        this.$toast.success(this.$t('layout.comingsoon') )
      }
    },

    async buyPocket(){
      
      let that = this
      that.$store.commit('handleShow', true)
      let useraddr = this.$store.state.globalAddress
      let PledgeContract = new web3.eth.Contract(contractaa.abiPocketLeague,contractaa.PocketLeagueToken)
      let UsdtContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.usdtToken)
      let resultUsdtallowance = await UsdtContract.methods.allowance(useraddr,contractaa.PocketLeagueToken).call({from:useraddr})
      console.log(resultUsdtallowance)
      let usdtAllowance = web3.utils.fromWei(resultUsdtallowance,'ether')
      //授权
      let maxmunber = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
      let minmax = Number(usdtAllowance) < that.usdtAmount

      if(Number(usdtAllowance) < that.usdtAmount){

        let resultUserApprove = await UsdtContract.methods.approve(contractaa.PocketLeagueToken,maxmunber).send({from:useraddr})
        if(resultUserApprove.status !="1"){
          that.$store.commit('handleShow', false)
          that.$toast.fail(that.$t('layout.error') )
          return;
        }
      }

      let resultBuyPocket = await PledgeContract.methods.buyPocket().send({from:useraddr})
      if(resultBuyPocket.status == "1"){
          //提交服务器
          let axiosResult = await axios.get(contractaa.APIURL+'?cmd=buypocket&tx='+resultBuyPocket.transactionHash);
          that.$toast.success(that.$t('layout.success') );
          that.$store.commit('handleShow', false)
        }else{
          that.$toast.fail(that.$t('layout.error'));
          that.$store.commit('handleShow', false)
        }


    },
    async getInfo(){
      let that = this
      let useraddr = this.$store.state.globalAddress
      let bindUserContract = new web3.eth.Contract(contractaa.abibindUser,contractaa.bindUserToken)
      let shareAddr = that.$route.query.share
      that.value = shareAddr
      let bindResult = await bindUserContract.methods.getleader(useraddr).call({from:useraddr})
      console.log(bindResult)
      if(bindResult == "0x0000000000000000000000000000000000000000"){
        that.show = true;
      }
      let PledgeContract = new web3.eth.Contract(contractaa.abiPocketLeague,contractaa.PocketLeagueToken)
      let resultPledge = await PledgeContract.methods.leagusAmount().call({from:useraddr})
      let pledgeAmount = web3.utils.fromWei(resultPledge,'ether')
      that.usdtAmount = Number(pledgeAmount)
      console.log(pledgeAmount)
    },
    async bindUser(){
        let that = this
        that.$store.commit('handleShow', true)
        let useraddr = this.$store.state.globalAddress
        let bindUserContract = new web3.eth.Contract(contractaa.abibindUser,contractaa.bindUserToken)
        let shareAddr = that.$route.query.share
        that.value = shareAddr
        let bindResult = await bindUserContract.methods.setRecommender(shareAddr).send({from:useraddr})
        console.log(bindResult)
        //console.log(JSON.stringify(bindResult))
        console.log("status:"+bindResult.status)
        console.log("hash:"+bindResult.transactionHash)
        
        if(bindResult.status == "1"){
          //提交服务器
          let axiosResult = await axios.get(contractaa.APIURL+'?cmd=binduser&tx='+bindResult.transactionHash);
          that.$toast.success(that.$t('layout.success') );
          that.show = false
          that.$store.commit('handleShow', false)
        }else{
           that.$toast.fail(that.$t('layout.error'));
          that.show = false
          that.$store.commit('handleShow', false)
        }
      
    },
  },
  mounted() {
      this.getInfo()
  },
};
</script>

<style scoped lang="less">
.home {
  position: relative;

  .positioning {
    height: 44px;
  }

  .home-title {
    font-weight: 400;
    font-size: 11px;
    color: #ffffff;
    line-height: 16px;
    opacity: 0.5;
  }

  .home-content {
    padding: 10px 15px 30px;

    .swipe-item {
      height: 198px;
      position: relative;
      padding: 30px 25px 0;

      >img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      >div {
        position: relative;
        z-index: 2;

        .label {
          font-weight: 600;
          font-size: 26px;
          color: #030303;
          line-height: 32px;

          span {
            color: #F37022;
          }
        }

        .desc {
          margin-top: 4px;
          font-size: 12px;
          color: #808080;
          line-height: 17px;
        }

        .btn {
          display: flex;

          >div {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 21px;
            min-width: 95px;
            height: 32px;
            background: #F37022;
            border-radius: 16px;
            padding: 7px 12px;
            font-size: 13px;
            color: #fff;
            line-height: 18px;
            cursor: pointer;

            >img {
              margin-left: 6px;
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .home-card {
      min-height: 90px;
      background: #fefefe;
      border-radius: 14px;
      border: 1px solid #f4f2f2;
      padding: 20px 15px 20px 17px;
      display: flex;
      align-items: center;
      margin-top: 20px;

      >img {
        width: 50px;
        height: 50px;
      }

      &-c {
        flex: 1;
        margin: 0 12px 0 12px;

        .label {
          font-weight: 600;
          font-size: 14px;
          color: #030303;
          line-height: 20px;

          span {
            color: #F37022;
          }
        }

        .desc {
          margin-top: 6px;
          font-size: 11px;
          color: #808080;
          line-height: 14px;
        }
      }

      .btn {
        width: 102px;
        height: 36px;
        background: #F37022;
        border-radius: 18px;
        font-weight: 500;
        font-size: 13px;
        color: #fff;
        line-height: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 9px 12px;
        justify-content: center;
      }
    }

    .home-card1 {
      margin-top: 20px;
      min-height: 80px;
      background: #f9f9f8;
      border-radius: 14px;
      padding: 15px;
      display: flex;
      align-items: center;

      >img {
        width: 50px;
        height: 50px;
      }

      &-c {
        flex: 1;
        margin-left: 10px;

        .label {
          font-weight: 600;
          font-size: 14px;
          color: #030303;
          line-height: 20px;
        }

        .desc {
          font-weight: 400;
          font-size: 11px;
          color: #808080;
          line-height: 14px;
          margin-top: 6px;
        }
      }

      .arrow {
        >img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>


<style lang="less">
.home-popup-box {
  background: transparent;

  .home-popup-content {
    width: 305px;
    height: 394px;
    background: url("../../assets/img/home/popup-bg.png") no-repeat center center / cover;
    position: relative;
    padding: 228px 20px 20px;

    .close {
      position: absolute;
      width: 26px;
      height: 26px;
      right: 15px;
      top: 15px;
      z-index: 1;
    }

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #030303;
      line-height: 22px;
      text-align: center;
    }

    .van-cell {
      height: 42px;
      background: #f9f9f8;
      border-radius: 12px;
      border: 1px solid #f4f2f2;
      display: flex;
      align-items: center;
      margin-top: 16px;

      &:after {
        display: none;
      }

      input {
        font-size: 12px;
        color: #030303;
        line-height: 20px;
      }
    }

    .btn {
      margin-top: 20px;
      height: 46px;
      background: #F37022;
      border-radius: 21px;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: center;
      font-weight: 500;
      font-size: 16px;
      color: #030303;
      line-height: 22px;
    }
  }
}
</style>